module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cliente/sectores/sector.component.scss
// module id = ./src/app/cliente/sectores/sector.component.scss
// module chunks = main